/** Capability gate for shells that reuse their project drawer for hub sections. */
export function hasNativeSectionMenu(): boolean {
  if (typeof window === 'undefined') return false;
  const host = window as unknown as {
    QuantisNativeBridge?: { hasNativeSectionMenu?: boolean | (() => boolean) };
  };
  const bridge = host.QuantisNativeBridge;
  const capability = bridge?.hasNativeSectionMenu;
  try {
    return typeof capability === 'function' ? capability.call(bridge) === true : capability === true;
  } catch {
    return false;
  }
}
